import { render, staticRenderFns } from "./ShareList.vue?vue&type=template&id=0a3957c3&scoped=true"
import script from "./ShareList.vue?vue&type=script&lang=js"
export * from "./ShareList.vue?vue&type=script&lang=js"
import style0 from "./ShareList.vue?vue&type=style&index=0&id=0a3957c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3957c3",
  null
  
)

export default component.exports